import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/virtual-assistant.svg'


const _hoisted_1 = { class: "faq flex justify-center w-full" }
const _hoisted_2 = {
  key: 1,
  class: "mt-8 md:mt-32 w-full flex items-center flex-col"
}
const _hoisted_3 = { class: "content-box mt-8" }
const _hoisted_4 = { class: "content-box p-8 flex flex-col justify-center sm:justify-start items-center sm:flex-row mt-8 sm:space-x-8 space-y-4 bg-white shadow-md rounded-md border-b-4 border-h-primary-500" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "virtual-assistant",
  class: "w-1/2 sm:w-32"
}, null, -1)
const _hoisted_6 = { class: "flex justify-between flex-col space-y-4" }
const _hoisted_7 = { class: "space-y-4" }
const _hoisted_8 = { class: "text-xl font-semibold" }
const _hoisted_9 = { class: "text-sm text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequestSupport = _resolveComponent("RequestSupport")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.requestSupport)
      ? (_openBlock(), _createBlock(_component_RequestSupport, {
          key: 0,
          onOnCloseSupport: _ctx.closeSupport,
          onOnSendEmail: _ctx.sendEmail
        }, null, 8, ["onOnCloseSupport", "onOnSendEmail"]))
      : _createCommentVNode("", true),
    (!_ctx.requestSupport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Accordion, { class: "accordion-faq-custom shadow-md" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq) => {
                  return (_openBlock(), _createBlock(_component_AccordionTab, {
                    key: faq,
                    header: 
              _ctx.$t('labels.generic', { pt: faq.question, en: faq.questionEN })
            
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", { pt: faq.answer, en: faq.answerEN })), 1)
                    ]),
                    _: 2
                  }, 1032, ["header"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Não encontrou o que você gostaria?",
                  en: "Didn't find what you'd like?",
                })), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Entre em contato com nosso Suporte, será um prazer ajudá-lo(a).",
                  en: "Contact our Support, it will be a pleasure to help you.",
                })), 1)
              ]),
              _createElementVNode("button", {
                class: "btn-primary w-full sm:w-1/2 rounded-md",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestSupport = true))
              }, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Falar com o suporte",
                en: "Talk to support",
              })), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}